import IconProps from "./iconProps"
import { colors } from "../../constants/colors"

/**
 * เมนูคืนค่ามัดจำแผง — เอกสารคำร้องพร้อมลูกศรคืนเงินกลับ (ทิศตรงข้ามกับไอคอนโอนมรดก)
 * ใช้ทั้งฝั่งเจ้าหน้าที่ (คืนค่ามัดจำแผง) และฝั่งผู้เช่า (ส่งคำร้องขอคืนค่ามัดจำแผง)
 * เพราะสองเมนูนี้ไม่เคยขึ้น sidebar พร้อมกัน (คนละ role)
 */
export default function DepositRefund(props: IconProps) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 2C4.34315 2 3 3.34315 3 5V19C3 20.6569 4.34315 22 6 22H18C19.6569 22 21 20.6569 21 19V5C21 3.34315 19.6569 2 18 2H6ZM5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V19C19 19.5523 18.5523 20 18 20H6C5.44772 20 5 19.5523 5 19V5Z"
                fill={props.color || `${colors.themeMainColor || "currentColor"}`}
            />
            <path
                d="M16 11C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H10.4142L11.7071 14.2929C12.0976 14.6834 12.0976 15.3166 11.7071 15.7071C11.3166 16.0976 10.6834 16.0976 10.2929 15.7071L7.29289 12.7071C6.90237 12.3166 6.90237 11.6834 7.29289 11.2929L10.2929 8.29289C10.6834 7.90237 11.3166 7.90237 11.7071 8.29289C12.0976 8.68342 12.0976 9.31658 11.7071 9.70711L10.4142 11H16Z"
                fill={props.color || `${colors.themeMainColor || "currentColor"}`}
            />
        </svg>
    )
}
